import React from 'react';
import { Input } from '@meitu/saas-ui';
import { color as handleColor, HsvaColor, hsvaToHex } from '../../../utils/color-convert';

type HexInputProps = {
    hasEyeDropper: boolean;
    hex: string;
    hsva: HsvaColor;
    setHex: (hex: string) => void;
    setHsva: (hsva: HsvaColor) => void;
    handleChange: (hsva: HsvaColor) => void;
    alpha: number;
};

const HexInput = ({ hasEyeDropper, hex, hsva, setHex, setHsva, handleChange, alpha }: HexInputProps) => {
    return (
        <div className={`c-color-sketch-picker__menu--input ${hasEyeDropper ? '' : 'w120'}`}>
            <Input
                prefix="#"
                value={hex}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const { target } = e;
                    const { value } = target;
                    setHex(value);
                }}
                onBlur={() => {
                    const result = handleColor(hex);
                    if (result.hex) {
                        setHex(result.hex.slice(1, 7));
                        setHsva({ ...result.hsva, a: alpha / 100 });
                        handleChange({ ...result.hsva, a: alpha / 100 });
                    } else {
                        setHex(hsvaToHex(hsva).slice(1, 7));
                    }
                }}
            />
        </div>
    );
};

export default HexInput;
